export default {
  icon: 'mdi-bank',
  text: 'Contas',
  permissions: [
    { name: 'accountTransactionIndex', text: 'Visualizar contas', value: 0 },
    { name: 'accountTransactionCreateEdit', text: 'Realizar lançamentos em contas', value: 0 },
    { name: 'accountTransactionCancel', text: 'Cancelar lançamentos em contas', value: 0 },
    { name: 'manageAccountsIndex', text: 'Gerenciar contas', value: 0 },
    { name: 'canViewCashFlowDashboard', text: 'Dashboard do caixa', value: 0 },
  ]
}